// DashboardCards.jsx
import React, { useEffect, useState } from "react";
import { Hourglass, Search, CheckCircle, Boxes, Users, User } from "lucide-react";

export default function DashboardCards() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("https://tailor.beezetsoftwaresolution.com/api/dashboard.php")
      .then(res => res.json())
      .then(json => setData(json));
  }, []);

  if (!data) return <div className="text-white text-center p-10">Loading...</div>;

  const cards = [
    { title: "Pending Orders", value: data.order_pending, icon: <Hourglass className="text-yellow-400" /> },
    { title: "Trial Orders", value: data.order_on_trial, icon: <Search className="text-blue-400" /> },
    { title: "Completed Orders", value: data.order_completed, icon: <CheckCircle className="text-green-500" /> },
    { title: "Processing Orders", value: data.order_on_processing, icon: <Boxes className="text-purple-400" /> },
    { title: "Total Customers", value: data.total_customers, icon: <Users className="text-indigo-400" /> },
    { title: "Total Employees", value: data.total_employees, icon: <User className="text-pink-400" /> },
  ];

  return (
    <div className="min-h-screen bg-gray-900 p-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <div key={index} className="bg-gray-800 p-6 rounded-2xl border border-gray-700">
            <div className="flex items-center gap-2 text-gray-200">{card.icon} {card.title}</div>
            <div className="text-4xl font-bold text-white mt-2">{card.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
